var generateStyle = function generateStyle(componentTheme) {
  return {
    container: {},
    bold: {
      fontWeight: componentTheme.boldFontWeight
    },
    normal: {
      fontWeight: componentTheme.normalFontWeight
    },
    emptyText: {
      display: 'block',
      margin: "".concat(componentTheme.emptyTextMargin, " 0 0 0")
    },
    page: {
      overflowY: 'scroll',
      overflowX: 'hidden',
      flex: '1',
      backgroundColor: componentTheme.pageBackgroundColor
    },
    sectionWrapper: {
      boxSizing: 'border-box',
      padding: "".concat(componentTheme.sectionWrapperPadding, " ").concat(componentTheme.sectionWrapperPaddingRight, " ").concat(componentTheme.sectionWrapperPadding, " 0"),
      minHeight: '3.25rem',
      marginBottom: componentTheme.sectionWrapperMargin
    },
    hiddenIcon: {
      verticalAlign: 'middle',
      outline: 'none'
    }
  };
};
export default generateStyle;